
import { useState } from 'react';
import { CSVLink } from "react-csv";
import {
  Container,
  Segment,
  Header,
} from 'semantic-ui-react'
import { useQuery, gql } from '@apollo/client';

import { ResponsiveContainer } from '../ResponsiveContainer';


const GET_PEOPLE_LIST = gql`
  query Peoplelist {
  peoplelist {
    dataJSON
  }
}
`;

const GET_AUDIT_DATA = gql`
  query Audit($tagId: Int) {
  audit(tagId: $tagId) {
    dataJSON
  }
}`;

const PeopleList = () => {
  const { loading, error, data } = useQuery(GET_PEOPLE_LIST);
  return (<>
    {!loading && !error && data.peoplelist && data.peoplelist[0] ? (
      <CSVLink data={JSON.parse(data.peoplelist[0].dataJSON)}>Download people list</CSVLink>
        ): "Generating people list"}
    </>
  )
}

const TruencyReport = ({ tagId }: {tagId: any}) => {
  const { loading, error, data } = useQuery(GET_AUDIT_DATA, {
    variables: { tagId: tagId === -1 ? null : tagId },
  });
  return (<>
    {!loading && !error && data.audit && data.audit[0] ? (
      <CSVLink data={JSON.parse(data.audit[0].dataJSON)}>Download truency report</CSVLink>
        ): "Generating truency report"}
    </>
  )
}

const ReportLoad = ({ reportName, label }: { reportName: string, label: string }) => {
  const buildQuery = (reportName: string) => {
    return gql`
      query ${reportName} {
      ${reportName} {
        dataJSON
      }
    }`;
  }

  const { loading, error, data } = useQuery(buildQuery(reportName));

  return (<>
    {!loading && !error && data[reportName] && data[reportName][0] ? (
      <CSVLink data={JSON.parse(data[reportName][0].dataJSON)}>Loaded {label}</CSVLink>
        ): "Generating report"}
    </>
  )
}
//Language 51
// VT 59
// SR 57


const Report = ({ reportName, label }: { reportName: string, label: string }) => {
  const [loaded, setLoad] = useState(false);

  return (
      <li style={{ marginTop: '0.25em' }}>
        { loaded ? <ReportLoad reportName={reportName} label={label} />: (<>
          <button onClick={() => setLoad(true)}>{label}</button>
        </>)}
      </li>
  );
}

const AdminTools = () => {
  const [loadVoctrainingReport, setLoadVoctrainingReport] = useState(false);
  const [loadSocialReport, setLoadSocialReport] = useState(false);
  const [loadLanguageReport, setLoadLanguageReport] = useState(false);
  const [loadEveryoneReport, setLoadEveryoneReport] = useState(false);
  const [loadPeopleList, setLoadPeopleList] = useState(false);
  const [tagId, setTagId] = useState(-1);

  return (
    <ResponsiveContainer>
      <Segment style={{ padding: '2em 0em' }} vertical>
        <Container>
            <Header as='h1' textAlign='center'>Admin reports</Header>
            <Header>Truency</Header>
            <ul>
              <li>
                <b>Vocational Training:</b> {" "}
                { loadVoctrainingReport ? <TruencyReport tagId={59}/> : (<>
                  <button onClick={() => setLoadVoctrainingReport(true)}>Generate truency report</button>
                </>)}
              </li>
              <li style={{ marginTop: '0.25em' }}>
                <b>Social and Recreation:</b> {" "}
                { loadSocialReport ? <TruencyReport tagId={57}/> : (<>
                  <button onClick={() => setLoadSocialReport(true)}>Generate truency report</button>
                </>)}
              </li>
              <li style={{ marginTop: '0.25em' }}>
                <b>Language:</b> {" "}
                { loadLanguageReport ? <TruencyReport tagId={51}/> : (<>
                  <button onClick={() => setLoadLanguageReport(true)}>Generate truency report</button>
                </>)}
              </li>
              <li style={{ marginTop: '0.25em' }}>
                { loadEveryoneReport ? <TruencyReport tagId={tagId}/> : (<>
                  <input type="text" pattern="[0-9]*" onChange={(e) => setTagId(Number(e.target.value))} placeholder="tagId"/>
<button onClick={() => setLoadEveryoneReport(true)}>Generate truency report</button>
                </>)}
              </li>
            </ul>
            <Header>Database overall</Header>
            <ul>
              <li>
                { loadPeopleList ? <PeopleList />: (<>
                  <button onClick={() => setLoadPeopleList(true)}>Generate people list</button>
                </>)}
              </li>
            </ul>
              <Header>Overall</Header>
            <ul>
              <Report reportName='numberOfCourses' label='Courses report' />
              <Report reportName='numberOfClasses' label='Classes report' />
              <Report reportName='numberOfAttendances' label='Attendances report' />
            </ul>
              <Header>All attendance</Header>
            <ul>
              <Report reportName='attendanceTotalBlock1' label='All attendance - November 2024' />
              <Report reportName='attendanceTotalBlock2' label='All attendance - January 2025' />
              <Report reportName='attendanceTotalBlock3' label='All attendance - April 2025' />
              <Report reportName='attendanceTotalBlock4' label='All attendance - July 2025' />
            </ul>
              <Header>Records</Header>
            <ul>
              <Report reportName='RecordsJan2026' label='Jan 2026 Records' />
              <Report reportName='RecordsApr2026' label='Apr 2026 Records' />
              <Report reportName='RecordsJul2026' label='Jul 2026 Records' />
            </ul>
              <Header>Enrolled</Header>
            <ul>
              <Report reportName='allEnrollmentsForNov2024' label='All enrollments for November 2024' />
              <Report reportName='allEnrollmentsForJan2025' label='All enrollments for January 2025' />
              <Report reportName='allEnrollmentsForApr2025' label='All enrollments for April 2025' />
              <Report reportName='allEnrollmentsForJul2025' label='All enrollments for July 2025' />
              <Report reportName='allEnrollmentsForOct2025' label='All enrollments for October 2025' />
              <Report reportName='allEnrollmentsForJan2026' label='All enrollments for January 2026' />
              <Report reportName='allEnrollmentsForApr2026' label='All enrollments for April 2026 - current block' />
              <Report reportName='allEnrollmentsForJoyyaGoodsLadies' label='All enrollments for jg ladies all time' />
              <Report reportName='numberOfParticipantsEnrolledNov2024' label='Participants Enrolled report by community - Nov 2024' />
              <Report reportName='numberOfParticipantsEnrolledJan2025' label='Participants Enrolled report by community - Jan 2025' />
              <Report reportName='numberOfParticipantsEnrolledApr2025' label='Participants Enrolled report by community - Apr 2025' />
              <Report reportName='numberOfParticipantsEnrolledJul2025' label='Participants Enrolled report by community - Jul 2025' />
              <Report reportName='numberOfParticipantsEnrolledOct2025' label='Participants Enrolled report by community - Oct 2025' />
              <Report reportName='numberOfParticipantsEnrolled2025' label='Participants Enrolled report by community 2025' />
            </ul>
        </Container>
      </Segment>
    </ResponsiveContainer>
  )
}

export { AdminTools }
